var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Divider, LILAC_400, WHITE, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { Fragment, useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { getInfoListWidgetStyles } from './InfoListWidgetStyles';
import { InfoListConstants } from './InfoListWidgetsConstants';
import AccordianChildComponent from './components/accordian-child/AccordianChildComponent';
import InfoListHeaderElementCard from './components/info-list-element-card/InfoListHeaderElementCard';
import InfoListFooter from './components/info-list-footer/InfoListFooter';
import InfoListHeader from './components/info-list-header/InfoListHeader';
export var InfoListWidgetComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'InfoListWidget' : _props$testID,
    style = props.style,
    initialOpen = props.initialOpen,
    _props$masterList = props.masterList,
    masterList = _props$masterList === void 0 ? [] : _props$masterList,
    buttonWidgetProps = props.buttonWidgetProps,
    _props$footerElementP = props.footerElementProps,
    footerElementProps = _props$footerElementP === void 0 ? {} : _props$footerElementP,
    onUserAction = props.onUserAction,
    headerElementProps = props.headerElementProps,
    _props$enableCollapsi = props.enableCollapsibleView,
    enableCollapsibleView = _props$enableCollapsi === void 0 ? false : _props$enableCollapsi,
    onToggleMetaData = props.onToggleMetaData,
    restProps = __rest(props, ["id", "testID", "style", "initialOpen", "masterList", "buttonWidgetProps", "footerElementProps", "onUserAction", "headerElementProps", "enableCollapsibleView", "onToggleMetaData"]);
  var accordionRef = useRef({});
  var _useState = useState(0),
    countOpenTabs = _useState[0],
    setCountOpenTabs = _useState[1];
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var _useState2 = useState(false),
    isInExpandedState = _useState2[0],
    setIsExpandedState = _useState2[1];
  var _useState3 = useState(InfoListConstants.DOWNCHEVRONBUTTONICON),
    viewButtonStateIconName = _useState3[0],
    setViewButtonIconNameState = _useState3[1];
  var _useState4 = useState(InfoListConstants.VIEW_MORE),
    viewButtonStateTitle = _useState4[0],
    setViewButtonTitleState = _useState4[1];
  var infoListWidgetStyles = getInfoListWidgetStyles();
  useEffect(() => {
    if (countOpenTabs > 0) {
      setIsExpandedState(true);
      setViewButtonIconNameState(InfoListConstants.UPCHEVRONBUTTONICON);
      setViewButtonTitleState(InfoListConstants.VIEW_LESS);
    } else {
      setIsExpandedState(false);
      setViewButtonIconNameState(InfoListConstants.DOWNCHEVRONBUTTONICON);
      setViewButtonTitleState(InfoListConstants.VIEW_MORE);
    }
  }, [countOpenTabs]);
  var collapseAll = () => {
    var _a, _b;
    for (var key in accordionRef.current) {
      (_b = (_a = accordionRef.current) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.toggle(false);
    }
  };
  var expandAll = () => {
    var _a, _b;
    for (var key in accordionRef.current) {
      (_b = (_a = accordionRef.current) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.toggle(true);
    }
  };
  var viewMoreButtonProps = {
    leftCta: {
      iconPosition: 'right',
      size: isLargeScreen ? InfoListConstants.MD : InfoListConstants.SM,
      buttonType: InfoListConstants.TERTIARY,
      iconName: viewButtonStateIconName,
      title: viewButtonStateTitle,
      onPress: () => isInExpandedState ? collapseAll() : expandAll()
    }
  };
  return _jsxs(Card, Object.assign({}, getTestId(testID), {
    style: [style],
    noHorizontalPadding: true
  }, restProps, {
    children: [_jsx(InfoListHeader, {
      headerElementProps: Object.assign(Object.assign({}, headerElementProps), {
        style: [infoListWidgetStyles.customCardPadding, headerElementProps === null || headerElementProps === void 0 ? void 0 : headerElementProps.style]
      }),
      onUserAction: onUserAction,
      testID: testID
    }), masterList === null || masterList === void 0 ? void 0 : masterList.map((mainItem, index) => {
      var _a, _b;
      return _jsxs(Fragment, {
        children: [_jsx(InfoListHeaderElementCard, Object.assign({
          id: id,
          setCountOpenTabs: setCountOpenTabs,
          item: mainItem,
          index: index,
          accordionRef: accordionRef,
          initialOpen: initialOpen,
          showAccordian: (mainItem === null || mainItem === void 0 ? void 0 : mainItem.isAccordianType) && ((_a = mainItem === null || mainItem === void 0 ? void 0 : mainItem.list) === null || _a === void 0 ? void 0 : _a.length) > 0,
          showRightPadding: mainItem === null || mainItem === void 0 ? void 0 : mainItem.showRightPadding,
          onToggleMetaData: onToggleMetaData,
          onUserAction: onUserAction
        }, {
          children: !!(mainItem === null || mainItem === void 0 ? void 0 : mainItem.list) && ((_b = mainItem === null || mainItem === void 0 ? void 0 : mainItem.list) === null || _b === void 0 ? void 0 : _b.map((item, childIndex) => {
            return _jsx(AccordianChildComponent, {
              index: childIndex,
              onUserAction: onUserAction,
              item: item,
              list: mainItem === null || mainItem === void 0 ? void 0 : mainItem.list
            }, "#" + childIndex);
          }))
        })), (mainItem === null || mainItem === void 0 ? void 0 : mainItem.showDivider) && _jsx(Divider, {
          height: 2,
          color: LILAC_400,
          shadowColor: WHITE,
          style: infoListWidgetStyles.divider
        })]
      }, index);
    }), enableCollapsibleView && _jsxs(View, Object.assign({
      style: infoListWidgetStyles.viewButtonWrapperContainer
    }, {
      children: [_jsx(Divider, {
        height: 1,
        color: LILAC_400
      }), _jsx(View, Object.assign({
        style: infoListWidgetStyles.viewButtonWrapperDiv
      }, {
        children: _jsx(ButtonWidget, Object.assign({}, viewMoreButtonProps))
      })), _jsx(Divider, {
        height: 1,
        color: LILAC_400
      })]
    })), _jsx(InfoListFooter, {
      footerElementProps: footerElementProps,
      buttonWidgetProps: buttonWidgetProps,
      enableCollapsibleView: enableCollapsibleView,
      onUserAction: onUserAction
    })]
  }));
};
InfoListWidgetComponent.genericRendererKey = 'AirInfoListWidget';